export const DEFAULT_RESOURCE_CATEGORY = "general";
